import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'CONTRATO_SERVICO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'CONTRATO_SERVICO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('contratoServicoForm', registro)
    ];
}

export function getLista(id_contrato) {
	const request = axios.get(`${consts.API_URL}/contratoServico?id_contrato=${id_contrato || 0}`);
	return {
		type: 'CONTRATO_SERVICO_LISTADO',
		payload: request
	};
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/contratoServico`, {
				...registro,
				valor_unitario: FormatUtils.formatarValorBanco(registro.valor_unitario, 2),
                valor_mensal: FormatUtils.formatarValorBanco(registro.valor_mensal, 2),
                percentual_imposto: FormatUtils.formatarValorBanco(registro.percentual_imposto, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_contrato));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/contratoServico`, {
				...registro,
				valor_unitario: FormatUtils.formatarValorBanco(registro.valor_unitario, 2),
                valor_mensal: FormatUtils.formatarValorBanco(registro.valor_mensal, 2),
                percentual_imposto: FormatUtils.formatarValorBanco(registro.percentual_imposto, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista(registro.id_contrato));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/contratoServico?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista(registro.id_contrato));
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}